<template>
    <v-dialog
        id="UpdateRequiredDialog-root"
        :model-value="showDialog"
        aria-labelledby="UpdateRequiredDialog-title"
        persistent
        max-width="440"
    >
        <v-card id="UpdateRequiredDialog-card">
            <v-card-title id="UpdateRequiredDialog-title">
                Studoku has updated
            </v-card-title>
            <v-card-text id="UpdateRequiredDialog-message">
                A new version of Studoku is required to continue. You have
                unsaved changes — copy anything you need, then reload. Reloading
                will discard unsaved edits.
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    id="UpdateRequiredDialog-dismiss"
                    variant="text"
                    @click="dismiss"
                >
                    Keep editing
                </v-btn>
                <v-btn
                    id="UpdateRequiredDialog-reload"
                    color="primary"
                    variant="flat"
                    @click="reload"
                >
                    Reload now
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';

import { isAnythingDirty } from '@/shared/composables/useDirtyState';
import { useAppStore } from '@/shared/store';

// Nothing here captures or restores the edit buffer.
const store = useAppStore();

// Sticky: keep-editing hides the dialog for good; blocked writes prevent loss.
const dismissed = ref(false);

// Dirtiness is watched too, so a dismissal cannot outlast the edit.
watch([() => store.reloadRequired, isAnythingDirty], ([required, dirty]) => {
    if (required && !dirty) {
        reload();
    }
});

const showDialog = computed(
    () => store.reloadRequired && isAnythingDirty.value && !dismissed.value,
);

function dismiss(): void {
    dismissed.value = true;
}

function reload(): void {
    window.location.reload();
}
</script>
